import { render, staticRenderFns } from "./DisplaySwitch.vue?vue&type=template&id=104b5977&scoped=true"
import script from "./DisplaySwitch.vue?vue&type=script&lang=js"
export * from "./DisplaySwitch.vue?vue&type=script&lang=js"
import style0 from "./DisplaySwitch.vue?vue&type=style&index=0&id=104b5977&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b5977",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104b5977')) {
      api.createRecord('104b5977', component.options)
    } else {
      api.reload('104b5977', component.options)
    }
    module.hot.accept("./DisplaySwitch.vue?vue&type=template&id=104b5977&scoped=true", function () {
      api.rerender('104b5977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/career/partials/TimeLine/DisplaySwitch.vue"
export default component.exports